import styled from "styled-components";
import { ModalDialog } from "../../StyledComponents/AddCard/Styles";

export const Container = styled.div`
  border: 1px solid #d8e0f0;
  border-radius: 8px;
  margin-right: 40px;
`;

export const TabPanel = styled.div`
  height: 31px;
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #d5ddec;
  display: flex;
  justify-content: flex-start;
`;

export const Tabs = styled.div`
  font-weight: ${(props) => props.active && "600"};
  font-size: 14px;
  line-height: 16px;
  margin-left: 32px;
  margin-top: 2px;
  margin-bottom: 7px;
  color: #2e2c34;
  cursor: pointer;

  ${(p) => {
    if (p.Line === false) {
      return `
              &::after {
                        content: "";
                        width: 100%;
                        height: 2px;
                        background: #407bff;
                        display:  block;
                        margin-top: 11px;
                        transform : translateX(-135px);
                        transition: transform 1s;
                         }
               `;
    }

    if (p.Line === true) {
      return `
              &::after {
                        content: "";
                        width: 100%;
                        height: 2px;
                        background: #407bff;
                        display:  block;
                        margin-top: 11px;
                        transform : translateX(0px);
                        transition: transform 1s;
                         }
               `;
    }
  }}
`;

export const AvatarFrame = styled.div`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background-color: #a8aebe;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
`;

export const AvatarTxt = styled.span`
  font-size: 16px;
  color: #ffffff;
  text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.15);
`;

export const TxtSpan = styled.span`
  color: ${(p) => (p.color ? p.color : "#000000")};
  font-size: 14px;
  line-height: 16px;
  font-family: "Inter", sans-serif;
  font-weight: ${(p) => p.fontWeight && p.fontWeight};
`;

export const PaymentStatus = styled(TxtSpan)`
  width: 41px;
  color: #20c9ac;
  background: rgba(32, 201, 172, 0.1);
  border-radius: 4px;
  padding: 2px 8px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalDiag = styled(ModalDialog)`
  width: ${(p) => (p.width ? p.width : "100vw")};
  height: ${(p) => (p.height ? p.height : "100vh")};
  background: ${(p) => (p.background ? p.background : "#ffffff")};
  position: relative;
`;

export const PaidStatus = styled.div`
  border: 3px solid #20c9ac;
  border-radius: 6px;
  text-align: center;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 2px;
  color: #20c9ac;
  padding: 5px 25px;
  position: absolute;
  top: 55px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  z-index: 5;
`;

// New styles for the redesign
export const InvoiceContainer = styled.div`
  background: #ffffff;
  width: 800px;
  margin: 0 auto;
  padding: 40px;
  font-family: "Inter", sans-serif;
  position: relative;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
`;

export const LogoContainer = styled.div`
  border: 1px dashed #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  min-width: 250px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoText = styled.div`
  font-weight: 600;
  font-size: 18px;
  color: #4a5568;
`;

export const InvoiceTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: #000000;
  text-align: right;
  margin: 0 0 10px 0;
  letter-spacing: -0.5px;
`;

export const InvoiceMeta = styled.div`
  text-align: right;
  font-size: 14px;
  color: #718096;
  line-height: 1.6;
`;

export const MetaLabel = styled.span`
  color: #a0aec0;
  margin-right: 5px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;
`;

export const InfoCard = styled.div`
  background: #f9fafb;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const CardLabel = styled.div`
  color: #4299e1;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 12px;
`;

export const CardName = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #2d3748;
  margin-bottom: 8px;
`;

export const CardDetail = styled.div`
  font-size: 13px;
  color: #718096;
  line-height: 1.5;
  margin-bottom: 4px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 30px;
`;

export const StyledThread = styled.thead`
  background-color: #3b82f6;
  color: white;
`;

export const StyledTh = styled.th`
  padding: 16px 24px;
  text-align: ${(props) => (props.align ? props.align : "left")};
  font-weight: 600;
  font-size: 14px;
`;

export const StyledTd = styled.td`
  padding: 16px 24px;
  border-bottom: 1px solid #edf2f7;
  color: #4a5568;
  font-size: 14px;
  text-align: ${(props) => (props.align ? props.align : "left")};

  &:last-child {
    font-weight: 600;
    color: #2d3748;
  }
`;

export const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 20px;
  padding-right: 24px;
`;

export const TotalRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 20px;
`;

export const TotalLabel = styled.span`
  font-size: 16px;
  color: #a0aec0;
  margin-right: 40px;
`;

export const TotalValue = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #2d3748;
`;

export const PaymentInfo = styled.div`
  text-align: right;
  font-size: 14px;
  color: #4a5568;
  margin-top: 10px;
  font-weight: 500;
`;

export const Divider = styled.div`
  height: 1px;
  background: #edf2f7;
  width: 300px;
  margin-bottom: 15px;
`;
